var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47288 8.33881L9.57443 14.8291C9.68612 14.9383 9.84051 15 10.0019 15C10.1633 15 10.3177 14.9383 10.4293 14.8291L16.5281 8.33881C16.6267 8.23478 16.676 8.09776 16.6648 7.95907C16.6536 7.82037 16.5828 7.69186 16.4687 7.60292L15.441 6.7926C15.2026 6.60428 14.847 6.62999 14.6422 6.85037L10.1066 11.77C10.0802 11.7987 10.0418 11.8153 10.0013 11.8153C9.96089 11.8153 9.92245 11.7987 9.89607 11.77L5.35879 6.84985C5.26029 6.74442 5.12134 6.6797 4.97216 6.66978C4.82273 6.6573 4.67427 6.70198 4.56054 6.79364L3.53232 7.60292C3.41753 7.6917 3.34615 7.82037 3.33456 7.95941C3.32333 8.09828 3.37332 8.2354 3.47288 8.33881Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown1);
export default __webpack_public_path__ + "static/media/chevron-down-1.213ae6ba.svg";
export { ForwardRef as ReactComponent };